import React from "react";
import "../styles/Directors.css";

const directors = [
  { name: "Alankar Misra", imageName: "Alankar_Misra", feedback: "Alankar has 31 years of experience in the pharmaceutical industry, having worked with top companies like Sarabhai Chemicals and Abbott Healthcare. From field representative to vertical head, he excels in sales across various specialties. A strong leader and mentor, Alankar fosters a performance-driven culture and is committed to creating a lasting impact in the pharmaceutical industry with Indiabulls." },
  { name: "Vikash Kumar Sharma", imageName: "Vikash_Sharma", feedback: "Vikash, MBA in Marketing, is a seasoned professional with 18 years of experience in Sales, Marketing, and Business Development. He is known for driving growth and successful product launches. He has held leadership roles at Zellevan Lifesciences, Ajanta Pharma, and more, focusing on excellence and growth in healthcare and pharmaceutical industry." },
  // { name: "S. K. Maheshwari", imageName: "S_K_Maheshwari", feedback: "S. K. Maheshwari, M.Sc. in Life Science | MBA in Marketing with 17+ years of experience in Healthcare, Pharmaceutical, and Brand Management, he has worked with top companies like Systopic, Torrent, and Cadila. Starting as a field representative and advancing to Head of Marketing, he specializes in brand launches, multi-crore growth, and establishing companies as industry leaders." }
];

const Directors = () => {
  return (
    <section id="directors" className="directors">
      <h1 className="directors-title">Our Directors</h1>
      <div className="directors-container">
        {directors.map((dir, index) => (
          <div className="directors-card" key={index}>
            <img className="directors-profile-image" alt={dir.name} src={`${process.env.PUBLIC_URL}/images/${dir.imageName}.jpg`}></img>
            <h2>{dir.name}</h2>
            <p className="directors-about">{dir.feedback}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Directors;